import EducationFilter from "core/components/filter/components/educationFilter";
import { Loading } from "core/components/loading/loading";
import useUserFilterPermissions from "core/hooks/useUserFilterPermissions";
import { useEffect, useState } from "react";

type VejlederBySpecialeFilterDropdownProps = {
    onChange: (specialer: string[]) => void;
    restrictedSpecialeIds?: string[];
    disable?: boolean;
}

const VejlederBySpecialeFilterDropdown = ({
    onChange, 
    restrictedSpecialeIds,
    disable=false
} : VejlederBySpecialeFilterDropdownProps) => {

    const { permissions, isLoadingPermissions } = useUserFilterPermissions();

    const [restrictedIds, setRestrictedIds] = useState<string[]>();

    useEffect(() => setRestrictedIds(restrictedSpecialeIds), [restrictedSpecialeIds]);

    return (
        <Loading isLoading={isLoadingPermissions}>
            <EducationFilter 
                onChange={(result) => onChange(result.specialer)} 
                visualizationConfig={{ showSpecialer: true }}
                restrictModel={{ specialer: restrictedIds, uddannelser: undefined }} 
                permissions={permissions}
                disable={disable}
            />
        </Loading>
    );
};

export default VejlederBySpecialeFilterDropdown;
